import {requiredTextAfterAttempt} from '../../../../../helpers/validations'

const validations = {
  title: [requiredTextAfterAttempt('title', 'homework-title-required')],
  instructions: [requiredTextAfterAttempt('instructions', 'homework-instructions-required')],
  group: [requiredTextAfterAttempt('group', 'homework-group-required')],
  students: [({attempted, students}) => {
    return (!attempted || students.length > 0) ? '' : 'homework-student-required'
  }]
}

export default validations
